import OrderList from "./List";
import OrderDetail from "./Detail";
import OrderEdit from "./Edit";
import { Icon } from "assets/icons";

const router = [
  {
    key: "order",
    title: "common.order",
    icon: <Icon.CustomIcon icon={Icon.faShoppingCart} />,
    children: [
      {
        key: "order-list",
        title: "common.orderList",
        path: "/order",
        component: OrderList,
        exact: true,
      },
    ],
  },
  {
    key: "order-detail",
    path: "/order/:id",
    component: OrderDetail,
    exact: true,
  },
  {
    key: "order-edit",
    path: "/order-edit/:id",
    component: OrderEdit,
    exact: true,
  },
];

export default router;
